import { NidusEntryId } from "../../../../Common/NidusClient/INidusClient";
import { reject } from "../../../../Common/TypingUtils";

import { PicklistDataItem } from "./Picklists/PicklistTypes";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelValue = any;

export type BindingPath = string;

export type AbsoluteBindingPath = `/${string}`;

export type ExternalBindingPath = string;

// Эту модель, которая лежит в redux-состоянии в поле viewModel, каждый узел кроме . является ViewModel
export interface ViewModel {
    children?: string[];
    error?: string[];
    warning?: string[];
    description?: string;
    id?: string;
    disabled?: boolean | string;
    visible?: boolean;
    disabledSending?: boolean;
    value?: string | undefined;
    autoValue?: string | undefined;
    autoFlag?: boolean | string;
    resourcesHash?: string;
    errorsCount?: number;
    warningsCount?: number;
    code?: string;
    picklist?: PicklistDataItem;
    normalized?: boolean;
    emptyUnitsVisible?: boolean;
    pencilOpened?: boolean;
    ignoreAutoFlag?: boolean;
    disableValueAutoInit?: boolean;

    // <Kladr fields>
    index?: string;
    regionCode?: string;
    district?: string;
    city?: string;
    settlement?: string;
    street?: string;
    house?: string;
    building?: string;
    room?: string;
    // </Kladr fields>

    // <FIO fields>
    bossValue?: string;
    agentValue?: string;
    senderInn?: string;
    nameorg?: string;
    // </FIO fields>

    /**
     * @summary Это поле проставляется при генерации авторасчётов
     */
    sum?: string;
    /**
     * @summary Это поле проставляется при генерации авторасчётов
     */
    count?: string;
    normalizationSource?: "server" | "client";

    //
    referencedId?: NidusEntryId;

    dirtyChangedPathMasks?: string;
    forceAutoValue?: boolean | undefined;
}

export type ViewModelFieldName = keyof ViewModel;

export function nonRegularFieldName(fieldName: string): ViewModelFieldName;
export function nonRegularFieldName(fieldName: undefined | string): undefined | ViewModelFieldName;
export function nonRegularFieldName(fieldName: undefined | string): undefined | ViewModelFieldName {
    // @ts-ignore
    return fieldName;
}

export function ensureIsKnownViewModelFieldName(fieldName: string): ViewModelFieldName {
    return getKnownViewModelFieldNames().has(fieldName as ViewModelFieldName)
        ? (fieldName as ViewModelFieldName)
        : reject(`[${fieldName}] is not known ViewModelFieldName`);
}

const keysOfViewModelFieldName = [
    "children",
    "error",
    "warning",
    "description",
    "id",
    "disabled",
    "visible",
    "disabledSending",
    "value",
    "autoValue",
    "autoFlag",
    "resourcesHash",
    "errorsCount",
    "warningsCount",
    "code",
    "picklist",
    "normalized",
    "emptyUnitsVisible",
    "pencilOpened",
    "ignoreAutoFlag",
    "disableValueAutoInit",
    "index",
    "regionCode",
    "district",
    "city",
    "settlement",
    "street",
    "house",
    "building",
    "room",
    "bossValue",
    "agentValue",
    "senderInn",
    "nameorg",
    "sum",
    "count",
    "normalizationSource",
    "referencedId",
    "dirtyChangedPathMasks",
    "forceAutoValue",
] as const;

type AllKeysOfViewModelFieldName = typeof keysOfViewModelFieldName;
type EnsureAllKeysAreIncluded<T extends readonly ViewModelFieldName[]> = T[number] extends ViewModelFieldName
    ? ViewModelFieldName extends T[number]
        ? T
        : never
    : never;

const allKeysOfViewModelFieldName: EnsureAllKeysAreIncluded<AllKeysOfViewModelFieldName> = keysOfViewModelFieldName;
const names: Set<ViewModelFieldName> = new Set(allKeysOfViewModelFieldName);

export function getKnownViewModelFieldNames(): Set<string> {
    return names;
}

export function isViewModelFieldName(name: string): name is ViewModelFieldName {
    return keysOfViewModelFieldName.includes(name as ViewModelFieldName);
}
